import React from 'react';

const SnapDataContext = React.createContext('snapData');

export default SnapDataContext;
